module.exports = __webpack_public_path__ + "img/banner-middle.13687db3.svg";